import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    container: {
      '& h2': {
        color: theme.palette.primary.main,
        fontSize: theme.typography.pxToRem(22),
        fontWeight: theme.typography.fontWeightBold,
      },
    },

    contentContainer: {
      [theme.breakpoints.up('sm')]: {
        marginTop: theme.spacing(4),
      },

      '& h3': {
        marginBottom: theme.spacing(2),
        color: theme.palette.primary.main,
        fontSize: theme.typography.pxToRem(16),
        fontWeight: theme.typography.fontWeightBold,
      },
    },

    selectContainer: {
      alignItems: 'center',

      [theme.breakpoints.up('sm')]: {
        justifyContent: 'flex-end',
      },
    },
    formControl: {
      minWidth: 190,
      top: -6,
    },
    select: {
      color: theme.palette.text.secondary,
      '&:before': {
        borderColor: 'white',
      },
      '&:after': {
        borderColor: 'white',
      },
    },
    selectIcon: {
      fill: theme.palette.text.secondary,
    },
  })
);

export default useStyles;
